import { APPLICATION_GROUP_BY, Route } from '@/core/entities/types/routes';
import NotFound from '@/core/views/notFound/notFound';
import { ROUTE_HEALTH_MANAGE, routeById } from '@/modules/healthManage/routes/routeById';
import { USER_TYPE } from '@/services/users/endpoints/users';
import ICONS from '@/shared/entities/constants/icons';
import { PERMISSIONS } from '@/utils/checkPermission';

export const dynamicRouteChildren = ({
  permissionsThatUserHas,
}: {
  permissionsThatUserHas: PERMISSIONS[];
}) => {
  const healthManageRouteChildren: Route[] = [];
  if (permissionsThatUserHas.length === 1) {
    const routeByPermission: Partial<Record<PERMISSIONS, Route>> = {
      [PERMISSIONS.COMPANY_DIGITAL_HOSPITAL_MANAGE]:
        routeById[ROUTE_HEALTH_MANAGE.DIGITAL_HOSPITAL],
      [PERMISSIONS.COMPANY_HEALTH_DATA_MANAGE]: routeById[ROUTE_HEALTH_MANAGE.HEALTH_DATA],
    };

    const routeChildren = routeByPermission[permissionsThatUserHas[0]] || {
      path: '*',
      Component: NotFound,
    };

    healthManageRouteChildren.push(routeChildren);
  } else {
    Object.values(ROUTE_HEALTH_MANAGE).forEach((routeId) => {
      healthManageRouteChildren.push(routeById[routeId]);
    });
  }

  healthManageRouteChildren[0].index = true;
  healthManageRouteChildren[0].meta = {
    groupedBy: APPLICATION_GROUP_BY.BROKER,
    showApplicationMenu: true,
    icon: ICONS.TRENDING_UP,
    nameMenu: 'Gestão de saúde',
    permission: {
      type: USER_TYPE.BROKER,
    },
  };

  return healthManageRouteChildren;
};
